if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      // Phones: the bar stays out while the product form's bottom is below the top of the screen (the form is on
      // screen or still to come), and shows once the form is scrolled past. With the plain viewport as the root an
      // observer only calls back when the form enters or leaves the screen, so a jump from below the form straight to
      // the top (an anchor link, "back to top", the iPhone status-bar tap), where the form goes from above the screen
      // to below it without ever being on it, left the bar over the buy box (QA Oct 30 2026, Q7). The root is
      // therefore the viewport stretched far down: the form intersects it exactly when its bottom is below the top
      // of the screen, so every change of that state, jumps included, calls back.
      const formObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      }, { rootMargin: '0px 0px 1000000px 0px' });

      // Desktop: the bar stays out while the product info column is on screen
      const infoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) formObserver.observe(this.productForm);
      if (this.productInfo) infoObserver.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
